import Logo from '../components/Logo'
import { useT } from '../i18n/useT'

export default function BookDemo() {
  const t = useT()

  const inputCls =
    'w-full h-11 rounded border border-slate-200 px-3.5 text-[15px] placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-brand-500/40 focus:border-brand-500 bg-white'

  return (
    <section className="bg-gradient-to-b from-brand-50 via-white to-white">
      <div className="mx-auto max-w-7xl px-8 py-20 grid place-items-center">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl border border-slate-100 shadow-[0_24px_60px_-24px_rgb(15_23_42/0.25)] p-9">
            <div className="flex justify-center mb-7">
              <Logo className="h-8 w-auto" />
            </div>
            <h1 className="text-2xl font-extrabold text-center mb-2">
              {t.bookDemo.title}
            </h1>
            <p className="text-sm text-ink-mute text-center mb-8">
              {t.bookDemo.sub}
            </p>

            <form className="space-y-3.5" onSubmit={(e) => e.preventDefault()}>
              <input type="text" required placeholder={t.bookDemo.name} className={inputCls} />
              <input type="email" required placeholder={t.bookDemo.email} className={inputCls} />
              <input type="text" required placeholder={t.bookDemo.company} className={inputCls} />
              <select required defaultValue="" className={`${inputCls} text-slate-500`}>
                <option value="" disabled>
                  {t.bookDemo.time}
                </option>
                {t.bookDemo.timeOptions.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
              <button
                type="submit"
                className="w-full h-11 rounded bg-brand-600 hover:bg-brand-700 transition-colors text-white font-semibold text-[15px]"
              >
                {t.bookDemo.submit}
              </button>
            </form>

            <p className="text-center text-xs text-slate-400 mt-5">
              {t.bookDemo.note}
            </p>
          </div>

          <p className="text-center text-[15px] text-ink-mute mt-6">
            {t.bookDemo.alt}{' '}
            <a
              href="mailto:info@simplepay.ca"
              className="font-semibold text-brand-700 hover:text-brand-800"
            >
              info@simplepay.ca
            </a>
          </p>
        </div>
      </div>
    </section>
  )
}
